// extracted by mini-css-extract-plugin
export default {"Order":"Order_Order__3GF4D","OrderDetail":"Order_OrderDetail__b4fGu","imagePart":"Order_imagePart__KCBMP","detailPart":"Order_detailPart__EPWEc"};